/*
 * Regras puras da árvore de documentos da avaliação (sem React, para testar em node).
 *
 * A lista vem plana do back: cada documento traz a pessoa dona (inscrito ou membro
 * da composição familiar) e a avaliação (status "A" aprovado, "N" negado, ou nula
 * quando ainda não foi avaliado). A árvore espelha a do PrimeFaces:
 * situação (Avaliados / Negados / Sem avaliação) → pessoa → documentos.
 */
export const STATUS_AVALIADO = 'A';
export const STATUS_NEGADO = 'N';
export const TIPO_PESSOA_INSCRITO = 'INSCRITO';

const GRUPOS = [
    {chave: 'AVALIADOS', titulo: 'Avaliados'},
    {chave: 'NEGADOS', titulo: 'Negados'},
    {chave: 'SEM_AVALIACAO', titulo: 'Sem avaliação'}
];

export const chaveGrupo = documento => {
    const status = documento && documento.avaliacao ? documento.avaliacao.status : null;

    if (status === STATUS_AVALIADO) {
        return 'AVALIADOS';
    }

    return status === STATUS_NEGADO ? 'NEGADOS' : 'SEM_AVALIACAO';
};

export const tituloPessoa = pessoa => {
    const nome = pessoa && pessoa.nome ? pessoa.nome : '';

    return pessoa && pessoa.tipo === TIPO_PESSOA_INSCRITO
        ? `Inscrito: ${nome}`
        : `Composição Familiar: ${nome}`;
};

export const tituloDocumento = documento => {
    const nome = documento && documento.documento ? documento.documento.nome : '';
    const descricao = documento && documento.descricao ? String(documento.descricao).trim() : '';

    return descricao ? `${nome} (${descricao})` : nome;
};

export const descricaoStatusAvaliacao = avaliacao => {
    if (!avaliacao) {
        return 'Sem avaliação';
    }

    return avaliacao.status === STATUS_AVALIADO ? 'Aprovado' : 'Negado';
};

/*
 * Os três grupos sempre existem (mesmo vazios), na ordem Avaliados, Negados, Sem avaliação.
 * Dentro do grupo, o inscrito vem primeiro e os membros mantêm a ordem em que aparecem.
 */
export const montarArvore = documentos => {
    const grupos = GRUPOS.map(grupo => ({...grupo, pessoas: []}));

    (documentos || []).forEach(documento => {
        const grupo = grupos.find(item => item.chave === chaveGrupo(documento));
        const titulo = tituloPessoa(documento.pessoa);
        let pessoa = grupo.pessoas.find(item => item.titulo === titulo);

        if (!pessoa) {
            pessoa = {
                chave: `${grupo.chave}|${titulo}`,
                titulo,
                inscrito: !!documento.pessoa && documento.pessoa.tipo === TIPO_PESSOA_INSCRITO,
                documentos: []
            };
            grupo.pessoas.push(pessoa);
        }

        pessoa.documentos.push({
            idInscricaoAnexo: documento.idInscricaoAnexo,
            titulo: tituloDocumento(documento)
        });
    });

    grupos.forEach(grupo => {
        // sort é estável: só leva o inscrito para o início.
        grupo.pessoas.sort((a, b) => Number(b.inscrito) - Number(a.inscrito));
    });

    return grupos;
};

/* Depois de recarregar a lista: mantém o documento selecionado se ele ainda existe. */
export const manterSelecao = (documentos, idSelecionado) => {
    if (idSelecionado === null || idSelecionado === undefined) {
        return null;
    }

    return (documentos || []).some(documento => documento.idInscricaoAnexo === idSelecionado)
        ? idSelecionado
        : null;
};

export const localizarDocumento = (documentos, idSelecionado) =>
    (documentos || []).find(documento => documento.idInscricaoAnexo === idSelecionado) || null;
